import React from 'react';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import IconButton from '@mui/material/IconButton';
import ListItemText from '@mui/material/ListItemText';
import { 
    Cancel as CancelIcon,
    Delete as TrashIcon,
    Error as ErrorIcon 
} from '@mui/icons-material';

import { Text, Services, Theme } from '@simplybenefits/sb-ui-library';

/**
 * @param notification
 * @param onClick
 * @param classes
 * @param id
 * @param testId
 * @returns {*}
 * @constructor
 */
const Notification = ({ notification, onClick, id, testId }) => {
    const timestamp = Services.dates.formatDateForDisplay(notification.timestamp * 1000, 'lll');
    const styles = {
        listItemIcon: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            width: 35
        },
        listItem: {
            maxWidth: 800,
            borderRadius: 2,
            boxShadow: '0 1px 2px rgba(0, 0, 0, .15)',
            marginLeft: 'auto',
            marginRight: 'atuo',
            marginBottom: 5,
            // Todo: Added
            minWidth: 500
        },
        listItemError: {
            paddingTop: 15,
            paddingBottom: 15
        },
        blue: {
            backgroundColor: '#E0F5F7'
        },
        yellow: {
            backgroundColor: '#F7F2C2'
        },
        red: {
            backgroundColor: '#FFCCCB'
        },
        inline: {
            display: 'inline'
        }
    };

    // Todo: Be aware, some strange if statements added to temporarily allow review of the notification system without refreshing the data

    if (notification.data && notification.data.errorTrace) {
        if (typeof notification.data.errorTrace === 'object') {
            notification.data.errorTrace = JSON.stringify(notification.data.errorTrace);
        }
    }

    if (notification.data && notification.data.message) {
        if (notification.metaID.toUpperCase().includes('ERR')) {
            return (
                <ListItem style={{ ...styles.listItem, ...styles.yellow, ...styles.listItemError }}>
                    <ListItemIcon style={ styles.listItemIcon }>
                        <CancelIcon style={{ color: '#414042' }} />
                    </ListItemIcon>

                    <ListItemText
                        disableTypography
                        primary={ <Text id={id || testId} medium customStyle={{ fontWeight: 600 }}>{ notification.data.message }</Text> }
                        secondary={
                            <React.Fragment>
                                <pre
                                    style={{
                                        fontFamily: '"AvenirLTPro-Light", sans-serif',
                                        margin: "5px 0 0 0",
                                        fontSize: '14px',
                                        overflowX: 'auto',
                                        whiteSpace: 'pre-wrap',
                                        wordWrap: 'break-word'
                                    }}
                                >
                                    { notification.data.errorTrace }
                                </pre>
                                <Text tiny margin="5px 0 0 0">{ `${ notification.type } | ${ timestamp }` }</Text>
                            </React.Fragment>
                        }
                    />

                    <IconButton aria-label="delete" onClick={ () => onClick(notification) } sx={{ color: Theme.colors.mainTextGrey }}>
                        <TrashIcon style={{ color: '#414042' }} />
                    </IconButton>
                </ListItem>
            );
        }
    }

    if (notification.data && notification.data.message) {
        return (
            <ListItem sx={{ ...styles.listItem, ...styles.blue }} onClick={ onClick } >
                <ListItemIcon sx={ styles.listItemIcon }>
                    <ErrorIcon style={{ color: '#414042' }} />
                </ListItemIcon>

                <ListItemText
                    disableTypography
                    primary={ <Text id={id || testId} medium customStyle={{ fontWeight: 600 }}>{ notification.data.message }</Text> }
                    secondary={ <Text tiny>{ `${ notification.type } | ${ timestamp }` }</Text> }
                />

                <IconButton aria-label="delete" onClick={ () => onClick(notification) } sx={{ color: Theme.colors.mainTextGrey }}>
                    <TrashIcon style={{ color: '#414042' }} />
                </IconButton>
            </ListItem>
        );
    }

    return (
        <ListItem sx={{ ...styles.listItem, ...styles.red }} onClick={ onClick } >
            <ListItemIcon sx={ styles.listItemIcon }>
                <ErrorIcon style={{ color: '#414042' }} />
            </ListItemIcon>

            <ListItemText
                disableTypography
                primary={ <Text id={id || testId} medium customStyle={{ fontWeight: 600 }}>{ "No Message" }</Text> }
                secondary={ <Text tiny>{ `${ notification.type } | ${ timestamp }` }</Text> }
            />

            <IconButton aria-label="delete" onClick={ () => onClick(notification) } sx={{ color: Theme.colors.mainTextGrey }}>
                <TrashIcon style={{ color: '#414042' }} />
            </IconButton>
        </ListItem>
    );
};

export default (Notification);